import { useQuery, useQueryClient } from "@tanstack/react-query";
import { BellRing } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const GROUPS = [
  { key: "nearby", label: "Friend nearby", hint: "A friend shares a city in a country on your Want to go list" },
  { key: "overlap", label: "Trip overlap", hint: "You and a friend are going to the same place at the same time" },
  { key: "contacts", label: "People you know", hint: "You date a trip or share your city where you have contacts" },
  { key: "joined", label: "Someone you know joined", hint: "A person from your phone book starts using the bucketlist" },
];
const CHOICES = [["all", "Phone + app"], ["app", "App only"], ["off", "Off"]];

export const AlertPrefsCard = () => {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["settings"], queryFn: api.settings });
  const prefs = data?.alert_prefs || {};
  const pick = async (key, v) => {
    qc.setQueryData(["settings"], (s) => ({ ...s, alert_prefs: { ...s.alert_prefs, [key]: v } }));
    try { qc.setQueryData(["settings"], await api.saveSettings({ alert_prefs: { [key]: v } })); }
    catch { toast.error("Couldn't save — try again"); qc.invalidateQueries({ queryKey: ["settings"] }); }
  };
  return (
    <section className="rounded-xl border border-white/10 bg-white/[0.03] p-4" data-testid="alert-prefs-card">
      <div className="flex items-center gap-2"><BellRing size={16} className="text-pink-300" /><h3 className="font-display font-semibold text-sm">Which alerts you get</h3></div>
      <ul className="mt-3 space-y-3">
        {GROUPS.map((g) => (
          <li key={g.key} data-testid={`alert-pref-${g.key}`}>
            <p className="text-sm">{g.label}</p>
            <p className="text-[11px] text-slate-500">{g.hint}</p>
            <div className="mt-1.5 inline-flex rounded-full bg-white/5 p-0.5" role="radiogroup" aria-label={g.label}>
              {CHOICES.map(([v, l]) => (
                <button key={v} type="button" role="radio" aria-checked={(prefs[g.key] || "all") === v} onClick={() => pick(g.key, v)}
                  className={`px-3 py-1 rounded-full text-[11px] transition-colors ${(prefs[g.key] || "all") === v ? "bg-pink-300 text-[#1a0612] font-medium" : "text-slate-400 hover:text-slate-200"}`}
                  data-testid={`alert-pref-${g.key}-${v}`}>{l}</button>
              ))}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};
